/*global Promise:true*/
// import co from 'co'
// import config from 'config'
import firebase from 'firebase'
import {selectUser} from './user'
import {getRef} from './common'

export function getAuth() {
  return firebase.auth().currentUser
}

export function initAuth() {
  return (dispatch,getState) => {
    firebase.auth().onAuthStateChanged((user) =>{
      if(!user && getState().me.uid) {
        dispatch(logout())
      }
    })
  }
}


export function logout() {
  return (dispatch) => {
    firebase.auth().signOut()
    localStorage.clear()
    location.reload()
  }
}

export function login() {
  return (dispatch) => {
    var provider = new firebase.auth.FacebookAuthProvider();
    provider.addScope('email,user_friends');
    firebase.auth().signInWithPopup(provider).then(function(result) {
      let token = result.credential.accessToken
      let user = result.user
      let {providerData,uid} = user
      let {uid:fbid='',email='',displayName:name=''} = providerData[0]

      let lastLogin = yyyymmddHHmmss(new Date())
      getRef('users').child(uid).set({uid,fbid,name,email,lastLogin})

      getRef('role/'+uid).once('value', snapshot=>{
        dispatch(selectUser({
          uid,
          fbid,
          email,
          name,
          role:snapshot.val(),
        }))
      })

    }).catch(function(error) {
      console.error('firebase.auth error',error)
    })

  }
}




/** WEBPACK FOOTER **
 ** ./src/app/actions/auth.js
 **/